import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerShadowBlurListItem = (props) => {
    const { dropShadowSettingsBlur, updateVisualizerSettings, maxDropShadowBlur } = props;
    
    const onShadowBlurChange = (value) => {
        previewHistoryBatch.start();
        
        updateVisualizerSettings({ 
            dropShadowSettings: { blur: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Blur'
            value={dropShadowSettingsBlur}
            displayMultiplier={100 / maxDropShadowBlur}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowBlurChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { blur: dropShadowSettingsBlur } = state.createPreview.present.videoSettings.visualizer.dropShadowSettings;
    const { maxDropShadowBlur } = state.create.maxValues;

    return { 
        dropShadowSettingsBlur,
        maxDropShadowBlur
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerShadowBlurListItem);